"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackedCustomDropdownMenu = void 0;

var _preact = require("preact");

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _CustomDropdownMenu = _interopRequireDefault(require("./CustomDropdownMenu"));

var TrackedCustomDropdownMenu = function TrackedCustomDropdownMenu(_ref) {
  var _item$children;

  var item = _ref.item,
      isHamburgerList = _ref.isHamburgerList;
  return (0, _preact.h)(_trackingLink.default, {
    tag: "li",
    className: "header-navigation_list-item main-menu",
    track: {
      type: "Mega Menu click on ".concat(item.key, " module"),
      event_source: 'control'
    }
  }, (0, _preact.h)(_CustomDropdownMenu.default, {
    name: item.name,
    isHamburgerList: isHamburgerList
  }, (_item$children = item.children) !== null && _item$children !== void 0 ? _item$children : []));
};

exports.TrackedCustomDropdownMenu = TrackedCustomDropdownMenu;